import React from "react";
import { Progress } from "antd";
import styled from "styled-components";
import importLightbulb from "../../../../assets/img/icons/import_lightbulb.svg";
import crossGreen from "../../../../assets/img/icons/crossGreen.svg";
import ListImport from "../../../../assets/img/ListImport.png";

interface AppProps {
  fileName: string;
  importedContacts: number;
  totalContacts: number;
  setShowImportProgressAsider: any;
  resetInputs: any;
  closeHeaderSiderOverlays: any;
  success?: boolean;
}

const FloatingPopoverProgress: React.FC<AppProps> = ({
  fileName,
  importedContacts,
  totalContacts,
  setShowImportProgressAsider,
  closeHeaderSiderOverlays,
  resetInputs,
  success = true,
}) => {
  const handleClose = () => {
    setShowImportProgressAsider(false);
    resetInputs();
    if (closeHeaderSiderOverlays) closeHeaderSiderOverlays();
  };

  return (
    <Wrapper>
      <div className="list-thumb">
        <img src={ListImport} />
      </div>
      <div className="content-wrapper">
        <div className="header-import d-flex justify-content-between">
          <span>
            <img src={importLightbulb} />
            <span className="label-header">
              Importing from {fileName.toLowerCase().includes(".csv") ? "CSV" : "Excel"}
            </span>
          </span>
          <img src={crossGreen} onClick={handleClose} />
        </div>
        <div className="importing-wrapper">
          {success === false ? (
            <span>An interval server error occurred while importing your list.</span>
          ) : totalContacts !== 0 ? (
            <>
              <Progress
                percent={parseInt(((importedContacts / totalContacts) * 100).toFixed(0))}
                showInfo={false}
                strokeColor="#09A43A"
                trailColor="#FFFFFF"
                strokeLinecap="square"
              />
              <span className="notice">
                Importing {importedContacts} of {totalContacts} contacts
              </span>
            </>
          ) : (
            <span>Processing your file...</span>
          )}
        </div>
      </div>
    </Wrapper>
  );
};

export default FloatingPopoverProgress;

const Wrapper = styled.div`
  position: relative;
  .list-thumb {
    background: transparent;
    text-align: center;
    position: absolute;
    z-index: -1;
    bottom: 115px;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    img {
      width: 75%;
    }
  }
  .content-wrapper {
    background: #fff;
    border-radius: 15px;
    .header-import {
      background: rgba(39, 206, 10, 0.15);
      padding: 14px 18px;
      border-radius: 15px 15px 0 0;
      .label-header {
        font-size: 18px;
        color: #09a43a;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        padding-top: 5px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 13px;
        }
      }
      span {
        img {
          margin-top: -7px;
        }
      }
      img {
        max-width: 22px;
        margin: 0 5px;
        cursor: pointer;
      }
    }
    .importing-wrapper {
      padding: 30px 40px 20px 40px;
      background: #fff;
      border-radius: 0 0 15px 15px;
      font-weight: 500;
      color: #7e7e7e;
      font-family: "Roboto", sans-serif;
      font-size: 14px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
      .ant-progress-inner {
        border: 1px solid #dadada;
      }
      .notice {
        color: #7e7e7e;
        font-size: 14px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        margin-top: 5px;
      }
    }
  }
`;
